module.exports = __webpack_public_path__ + "back_in_stock_illustration.c78aa1a84623be76a340d963417a719f.svg";